const publicKey = `-----BEGIN PUBLIC KEY-----
MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAm/I7vXGVDuFu8C1RXrmC
sBplB/oTbN7zknWZzUoIj9fxT3O8V2Y25xl7w1A79CCMrDtPTohZrL398yQ28hsJ
Zg24i/620D06QJ/+z3nygo5jNC9vSIz78cdRtPJbVYLA2gBlHU3LYSSddCvSZZs7
IN7RtRapaRlEbhPvutMGZLZhRyyIX5wYrbd/IQWT9vdw85lwAUPDxrOSHiyWKSBm
0cF7mkYNTLtHNbACImlPPlSUv37XFlIFg5/iL/LJe9cPULYzR/4y2i2LkXepcme9
fVSW7zwb2ZmiJY0l32AIYdxeu7A+z0bcRJ56xW1w/WLeBI+MxW1W7ywRk0qtcmf0
zwIDAQAB
-----END PUBLIC KEY-----`

let forgeInstance = null
let forgeLoading = null

function loadForge() {
  if (forgeInstance) {
    return Promise.resolve(forgeInstance)
  }
  if (!forgeLoading) {
    forgeLoading = import(/* webpackChunkName: "chunk-forge" */ 'node-forge').then((mod) => {
      forgeInstance = mod.default || mod
      return forgeInstance
    })
  }
  return forgeLoading
}

export async function encrypt(text, store) {
  const forge = await loadForge()
  const key = forge.util.createBuffer(store.state.key, 'utf8')
  const iv = forge.util.createBuffer(store.state.iv, 'utf8')
  const cipher = forge.cipher.createCipher('AES-CBC', key)
  cipher.start({ iv })
  cipher.update(forge.util.createBuffer(text, 'utf8'))
  cipher.finish()
  return forge.util.bytesToHex(cipher.output.getBytes())
}

export async function decrypt(text, store) {
  const forge = await loadForge()
  const key = forge.util.createBuffer(store.state.key, 'utf8')
  const iv = forge.util.createBuffer(store.state.iv, 'utf8')
  const decipher = forge.cipher.createDecipher('AES-CBC', key)
  decipher.start({ iv })
  decipher.update(forge.util.createBuffer(forge.util.hexToBytes(text)))
  decipher.finish()
  return decipher.output.toString('utf8')
}

export async function encryptWithPublicKey(data) {
  const forge = await loadForge()
  const pubKey = forge.pki.publicKeyFromPem(publicKey)
  const encrypted = pubKey.encrypt(String(data), 'RSAES-PKCS1-V1_5')
  return forge.util.encode64(encrypted)
}
